import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap } from 'rxjs';
import { RouteSelectionActionTypes } from '../actions/route-selection.action';
import { ChangeCurrentCpId, ChangeCurrentCsaId, ChangeCurrentMcpId, ClearCurrentCsa, ClearCurrentMcp } from '../actions';

@Injectable()
export class RouterSelectionEffects {
  constructor(private actions$: Actions) {}

  routeChanged$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RouteSelectionActionTypes.RouteChanged),
      concatMap(({ cpId, mcpId, csId }) => {
        const actions = [];
        if (cpId !== null) {
          actions.push(new ChangeCurrentCpId(cpId));
        }

        if (mcpId !== null) {
          actions.push(new ChangeCurrentMcpId(mcpId));
        } else {
          actions.push(new ClearCurrentMcp());
        }

        if (csId !== null) {
          actions.push(new ChangeCurrentCsaId(csId));
        } else {
          actions.push(new ClearCurrentCsa());
        }

        return actions;
      }),
    ),
  );
}
